import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "./../store/action/auth/index";

import Setting from "../page/Setting";
const Main = lazy(() => import("../page/Step/Main"));
const Vote = lazy(() => import("../page/Vote"));

export const Router = ({ mode, changeMode }) => {
  // localStorage.setItem("token", process.env.REACT_APP_Token);
  const dispatch = useDispatch();

  const fetchLogin = async ({ countryCode, mobile, password }) => {
    await login({
      mobile: countryCode + mobile,
      password,
    })(dispatch);
  };

  useEffect(() => {
    fetchLogin({
      countryCode: "20",
      mobile: "1099093619",
      password: "123456789",
    });
  }, []);
  return (
    <Routes>
      <Route path="/Main" element={<Main />} />
      <Route path="/setting" element={<Setting />} />

      <Route path="/*" element={<Vote />} />

      {/* <Route
        path="login"
        element={<SuspenseComponent>{<LoginPage />}</SuspenseComponent>}
      />
      <Route path="/*" element={<Main />} /> */}

      {/* <Route
        path="404"
        element={/* <NotFound /> 
      />
      <Route path="*" element={<Navigate to="/404" />} /> */}
    </Routes>
  );
};

export default Router;
